import React, { useState } from 'react';

import { LIVE_CHAT_TEST_IDS } from '../../lib/testIds';
import { FeedbackWrapper } from './ChatFeedback.styles';
import { FeedbackStars } from './FeedbackStars';
import { FeedbackCommentForm } from './FeedbackCommentForm';
import { FeedbackDone } from './FeedbackDone';
import { FeedbackCloseButton } from './FeedbackCloseButton';

type ChatFeedbackProps = {
  contactId?: string;
  onClickClose?: () => void;
};

type FeedbackStep = 'stars' | 'comment' | 'done';

export const ChatFeedback: React.FC<ChatFeedbackProps> = ({ contactId, onClickClose }) => {
  const [currentStep, setCurrentStep] = useState<FeedbackStep>('stars');

  const steps: Record<FeedbackStep, () => React.ReactNode> = {
    stars: () => <FeedbackStars contactId={contactId} onSuccess={() => setCurrentStep('comment')} />,
    comment: () => <FeedbackCommentForm contactId={contactId} onSuccess={() => setCurrentStep('done')} />,
    done: () => <FeedbackDone />
  };

  return (
    <FeedbackWrapper data-testid={LIVE_CHAT_TEST_IDS.FEEDBACK}>
      {steps[currentStep]()}
      {currentStep !== 'stars' && <FeedbackCloseButton onClick={onClickClose} />}
    </FeedbackWrapper>
  );
};

ChatFeedback.displayName = 'ChatFeedback';
